import { gql } from '@apollo/client';

export const CALCULATED_CREATIVE_DATA_WITH_COUNTRIES = gql`
  fragment calculatedCreativeDataWithCountries on CalculatedCreativeDataForAd {
    status
    transcodingStatus
    allowedPublisherList
    approvedCountries
    assetTagList {
      id
      displayName
    }
    rejectionReasons {
      assetId
      declines {
        reason
        externalComment
        internalComment
      }
    }
  }
`;
